/// <reference types="vite/client" />

interface ImportMetaEnv {
    readonly VITE_NODE_ENV: string;
    readonly VITE_WS_URL: string;
    readonly VITE_API_URL: string;
    readonly VITE_TRANS_ENV: string;
    readonly VITE_TRANS_API_URL: string;
    readonly VITE_DATABASE_API: string;
    readonly VITE_AGREEMENT_VERSION: string;
    readonly VITE_MATOMO_SITE_ID: string;
    readonly VITE_GOOGLE_TRACKING_CODE: string;
    readonly VITE_SENTRY_DSN: string;
    readonly VITE_SCRIPT_DEBUG: string;
    readonly VITE_HEALTH_CHECK_SECRET: string;
}

interface ImportMeta {
    readonly env: ImportMetaEnv;
}

type ProjectEnvVariablesType = ImportMetaEnv;

// Environment Variable Template to Be Replaced at Runtime
const projectEnvVariables: ProjectEnvVariablesType = {
    VITE_NODE_ENV: '${VITE_NODE_ENV}',
    VITE_WS_URL: '${VITE_WS_URL}',
    VITE_API_URL: '${VITE_API_URL}',
    VITE_TRANS_ENV: '${VITE_TRANS_ENV}',
    VITE_TRANS_API_URL: '${VITE_TRANS_API_URL}',
    VITE_DATABASE_API: '${VITE_DATABASE_API}',
    VITE_AGREEMENT_VERSION: '${VITE_AGREEMENT_VERSION}',
    VITE_MATOMO_SITE_ID: '${VITE_MATOMO_SITE_ID}',
    VITE_GOOGLE_TRACKING_CODE: '${VITE_GOOGLE_TRACKING_CODE}',
    VITE_SENTRY_DSN: '${VITE_SENTRY_DSN}',
    VITE_SCRIPT_DEBUG: '${VITE_SCRIPT_DEBUG}',
    VITE_HEALTH_CHECK_SECRET: '${VITE_HEALTH_CHECK_SECRET}',
};

// Helper to check if a value is a placeholder
const isPlaceholder = (value: any) => typeof value === 'string' && value.startsWith('${') && value.endsWith('}');

// Returning the variable value from runtime or obtained as a result of the build
export const getProjectEnvVariables = (): {
    envVariables: ProjectEnvVariablesType;
} => ({
    envVariables: {
        VITE_NODE_ENV: !isPlaceholder(projectEnvVariables.VITE_NODE_ENV)
            ? projectEnvVariables.VITE_NODE_ENV
            : import.meta.env.VITE_NODE_ENV,
        VITE_WS_URL: !isPlaceholder(projectEnvVariables.VITE_WS_URL)
            ? projectEnvVariables.VITE_WS_URL
            : import.meta.env.VITE_WS_URL,
        VITE_API_URL: !isPlaceholder(projectEnvVariables.VITE_API_URL)
            ? projectEnvVariables.VITE_API_URL
            : import.meta.env.VITE_API_URL,
        VITE_TRANS_ENV: !isPlaceholder(projectEnvVariables.VITE_TRANS_ENV)
            ? projectEnvVariables.VITE_TRANS_ENV
            : import.meta.env.VITE_TRANS_ENV,
        VITE_TRANS_API_URL: !isPlaceholder(projectEnvVariables.VITE_TRANS_API_URL)
            ? projectEnvVariables.VITE_TRANS_API_URL
            : import.meta.env.VITE_TRANS_API_URL,
        VITE_DATABASE_API: !isPlaceholder(projectEnvVariables.VITE_DATABASE_API)
            ? projectEnvVariables.VITE_DATABASE_API
            : import.meta.env.VITE_DATABASE_API,
        VITE_AGREEMENT_VERSION: !isPlaceholder(projectEnvVariables.VITE_AGREEMENT_VERSION)
            ? projectEnvVariables.VITE_AGREEMENT_VERSION
            : import.meta.env.VITE_AGREEMENT_VERSION,
        VITE_MATOMO_SITE_ID: !isPlaceholder(projectEnvVariables.VITE_MATOMO_SITE_ID)
            ? projectEnvVariables.VITE_MATOMO_SITE_ID
            : import.meta.env.VITE_MATOMO_SITE_ID,
        VITE_GOOGLE_TRACKING_CODE: !isPlaceholder(projectEnvVariables.VITE_GOOGLE_TRACKING_CODE)
            ? projectEnvVariables.VITE_GOOGLE_TRACKING_CODE
            : import.meta.env.VITE_GOOGLE_TRACKING_CODE,
        VITE_SENTRY_DSN: !isPlaceholder(projectEnvVariables.VITE_SENTRY_DSN)
            ? projectEnvVariables.VITE_SENTRY_DSN
            : import.meta.env.VITE_SENTRY_DSN,
        VITE_SCRIPT_DEBUG: !isPlaceholder(projectEnvVariables.VITE_SCRIPT_DEBUG)
            ? projectEnvVariables.VITE_SCRIPT_DEBUG
            : import.meta.env.VITE_SCRIPT_DEBUG,
        VITE_HEALTH_CHECK_SECRET: !isPlaceholder(projectEnvVariables.VITE_HEALTH_CHECK_SECRET)
            ? projectEnvVariables.VITE_HEALTH_CHECK_SECRET
            : import.meta.env.VITE_HEALTH_CHECK_SECRET,
    },
});
// Build timestamp: 1793714928
